import React, { useEffect, useState } from "react";
import { EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getTenantScope, setTenantScope } from "@/lib/api";
import { toast } from "sonner";

export default function ScopeBanner() {
  const [scope, setScope] = useState(getTenantScope());

  useEffect(() => {
    const onChange = () => setScope(getTenantScope());
    window.addEventListener("isoquest:scope-changed", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("isoquest:scope-changed", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  if (!scope || scope.role !== "client") return null;

  const exit = () => {
    setTenantScope(null);
    toast.success("Back to staff view");
  };

  return (
    <div
      data-testid="global-scope-banner"
      className="fixed left-0 right-0 top-16 z-40 px-3 sm:px-5 py-2 flex items-center gap-3 bg-amber-100/95 dark:bg-amber-500/25 backdrop-blur border-b border-amber-300 dark:border-amber-500/40 text-amber-900 dark:text-amber-100 shadow-sm"
    >
      <EyeOff className="h-4 w-4 shrink-0" />
      <div className="text-xs font-semibold min-w-0 truncate">
        Simulator: viewing as <span className="font-bold">{scope.slug}</span> client user — tenant boundary enforced by API on every request.
      </div>
      <Button
        data-testid="global-scope-exit"
        size="sm"
        variant="outline"
        className="ml-auto h-7 border-amber-300 bg-white/70 hover:bg-white shrink-0"
        onClick={exit}
      >
        Exit simulator
      </Button>
    </div>
  );
}
